import React from 'react';
import { ReferenceCard } from '../../components/ReferenceCard/ReferenceCard';
import { useHistory } from 'react-router-dom';
import getCardDetails from '../../util/getCardDetails';
import { Button } from 'dw-us-ui';

const ReferenceCardWrapper = ({ refCard, brand, pathName }) => {
  let cardDetails = getCardDetails(refCard?.blocks);

  const hasButtonTitle = cardDetails?.text;
  const btnUrl = cardDetails?.url;
  const openInNewTab = cardDetails?.newtab === true ? '_blank' : '_top';
  const buttonLinkComponent = (
    <span>
      <a href={`https://${location.host}${pathName}/${btnUrl}`} target={openInNewTab}>
        <Button brand={brand} buttonType="primary" buttonSize="small" className={`${brand.toLowerCase()}`}>
          {hasButtonTitle}
        </Button>
      </a>
    </span>
  );

  return (
    <div className="h-100" data-testid="reference-card-wrapper">
      <ReferenceCard cardDetails={cardDetails}>{buttonLinkComponent}</ReferenceCard>
    </div>
  );
};

export { ReferenceCardWrapper };
